import { render, staticRenderFns } from "./BackofficeOutrasSolicitacoesDoPaciente.vue?vue&type=template&id=f62fa0b8&scoped=true"
import script from "./BackofficeOutrasSolicitacoesDoPaciente.vue?vue&type=script&lang=ts"
export * from "./BackofficeOutrasSolicitacoesDoPaciente.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeOutrasSolicitacoesDoPaciente.vue?vue&type=style&index=0&id=f62fa0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62fa0b8",
  null
  
)

export default component.exports